"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const MiniProviderCard_styles_1 = require("./MiniProviderCard.styles");
const constants_1 = require("../common/util/constants");
const useProviderContent_1 = require("../common/util/useProviderContent");
const ViewAvailabilityButton = ({ provider, config, availability, onViewAvailability, viewAvailabilityUrl, viewAvailabilityLinkTarget, intl }) => {
    const { id, name } = (0, useProviderContent_1.useProviderContent)({
        provider,
        availability,
        config
    });
    return (react_1.default.createElement(MiniProviderCard_styles_1.AvailabilityButton, { "data-testid": `mini-provider-card-button-${id}`, rel: "noopener noreferrer", target: viewAvailabilityLinkTarget, href: viewAvailabilityUrl, onClick: onViewAvailability, draggable: false, "aria-label": intl.formatMessage(constants_1.messages.ariaViewAvailability, {
            name
        }) },
        react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, constants_1.messages.viewAvailability))));
};
exports.default = (0, intl_1.injectIntl)(ViewAvailabilityButton);
//# sourceMappingURL=ViewAvailabilityButton.js.map